var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import { classNames } from '@shapeable/utils';
var cls = classNames('icon-logo');
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { Icon } from './icon';
import { HTML } from './html';
import { useSiteOwnerName } from '../hooks/use-site-owner-name';
import { EntityIcon } from '@shapeable/icons';
import { useEnv } from '../hooks/use-env';
export var IconLogoDefaultProps = {
  isSmall: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 0;\n    color: ", ";\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n    font-size: ", ";\n  "], ["\n    margin: 0;\n    color: ", ";\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n    font-size: ", ";\n  "])), theme.COLOR('strong'), theme.FONT_SIZE(14)),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(16)),
  desktopLarge: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(20))
});
var LabelStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-weight: 300;\n    text-decoration: none;\n    ", "\n  "], ["\n    font-weight: 300;\n    text-decoration: none;\n    ", "\n  "])), function (props) {
    return props._color && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.COLOR(props._color));
  })
});
var IconStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-top: 1px;\n    flex-shrink: 0;\n    margin-right: ", ";\n    width: 14px;\n    height: 14px;\n\n    ", "\n\n    svg {\n      width: 100%;\n      height: 100%;\n    }\n\n  "], ["\n    margin-top: 1px;\n    flex-shrink: 0;\n    margin-right: ", ";\n    width: 14px;\n    height: 14px;\n\n    ", "\n\n    svg {\n      width: 100%;\n      height: 100%;\n    }\n\n  "])), theme.UNIT(2), function (props) {
    return props.isSmall && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "])));
  }),
  tablet: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    width: 18px;\n    height: 18px;\n    display: block;\n\n  "], ["\n    width: 18px;\n    height: 18px;\n    display: block;\n\n  "]))),
  desktopLarge: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    width: 32px;\n    height: 32px;\n  "], ["\n    width: 32px;\n    height: 32px;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.h1(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Icon: styled(Icon)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Label: styled(HTML)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles)
};
export var IconLogo = function (props) {
  var className = props.className,
    iconColor = props.iconColor,
    icon = props.icon,
    isSmall = props.isSmall,
    variant = props.variant;
  var env = useEnv();
  var ownerName = useSiteOwnerName();
  var label = props.label || env.ICON_LOGO_LABEL || ownerName || 'platform';
  var IconComponent = icon || EntityIcon;
  var color = variant === 'inverted' ? 'light' : iconColor || env.ICON_LOGO_COLOR || 'primary';
  var labelColor = variant === 'inverted' ? 'light' : 'strong';
  return React.createElement(My.Container, {
    isSmall: isSmall,
    className: cls.name(className)
  }, IconComponent && React.createElement(My.Icon, {
    isSmall: isSmall,
    color: color
  }, React.createElement(IconComponent, null)), React.createElement(My.Label, {
    _color: labelColor,
    isSmall: isSmall,
    text: label
  }));
};
IconLogo.defaultProps = IconLogoDefaultProps;
IconLogo.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;